import Vue from 'vue';
import App from './App.vue';
import router from './router/';
import store from './store';
import vuetify from './plugins/vuetify';

import './services/http';
import './plugins/formGenerator';
import './plugins/styles';
import './plugins/Events';
import './plugins/scroll';
import './plugins/vueNumber';
import './plugins/vuePlyr';
import './plugins/vueTheMask';
import './plugins/vueSanitize.js';

Vue.config.productionTip = false;

export default new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
